import { batch, computed, signal } from "@preact/signals-react"

// Table data
export const tableData = signal([])
export const totalCount = signal(0)
export const currentPage = signal(0)
export const pageSize = signal(20)

// Edit mapping drawer
export const editMappingDrawer = signal(null)

// Multiple mapping selection
export const multipleRowsSelected = signal([])
export const multipleRowsSent = signal([])
export const loadingRows = signal([])

// Image comparison modal
export const imageComparisonModal = signal(null)

// Row cap awareness: the listing is not paginated server-side, so the backend
// caps the rows it returns and reports whether matching rows were dropped
export const isTruncated = signal(false)
export const rowLimit = signal(0)
export const totalRows = signal(0)

// Stats data
export const statsData = signal(null)
export const isLoadingStats = signal(false)

// Loading states
export const isLoadingFilters = signal(false)
export const isLoadingTable = signal(false)

// Filters
export const selectedMarkets = signal([])
export const selectedSites = signal([])   // array of option objects: [{value, label, countryCode}]
export const sitesOptions = signal([])
export const selectedBrands = signal([])
export const searchText = signal('')
export const onlyNewProducts = signal(false)
export const onlyUnmapped = signal(false)
export const groupByField = signal(null) // null | 'reference' | 'product_url'

// Custom date range for "new products" filter (null = use default 7 days)
export const newProductsDateFrom = signal(null)
export const newProductsDateTo = signal(null)

// Recent data filter (by end_date) - enabled by default, 30 days
export const recentDataEnabled = signal(true)
export const recentDataDays = signal(30)
// Custom date range for recent data (null = use recentDataDays)
export const recentDataDateFrom = signal(null)
export const recentDataDateTo = signal(null)

export const filtersValue = computed(() => ({
    markets: selectedMarkets.value || [],
    sites: (selectedSites.value || []).map(s => s.value),
    brands: selectedBrands.value || [],
    text: searchText.value || '',
    only_new: onlyNewProducts.value,
    new_products_from: newProductsDateFrom.value || null,
    new_products_to: newProductsDateTo.value || null,
    // Recent data filter (by end_date)
    recent_data_enabled: recentDataEnabled.value,
    recent_data_days: recentDataDays.value,
    recent_data_from: recentDataDateFrom.value || null,
    recent_data_to: recentDataDateTo.value || null,
    limit: 20000
}))

export const tableFiltersValue = computed(() => ({
    ...filtersValue.value,
    only_unmapped: onlyUnmapped.value
}))

export const canSearch = computed(() => 
    selectedMarkets.value.length > 0 || selectedSites.value.length > 0 || selectedBrands.value.length > 0
)

export const clearProductsReviewSignals = () => batch(() => {
    tableData.value = []
    totalCount.value = 0
    isTruncated.value = false
    rowLimit.value = 0
    totalRows.value = 0
    currentPage.value = 0
    pageSize.value = 20
    isLoadingFilters.value = false
    isLoadingTable.value = false
    selectedMarkets.value = []
    selectedSites.value = []
    selectedBrands.value = []
    searchText.value = ''
    onlyNewProducts.value = false
    onlyUnmapped.value = false
    groupByField.value = null
    newProductsDateFrom.value = null
    newProductsDateTo.value = null
    recentDataEnabled.value = true
    recentDataDays.value = 30
    recentDataDateFrom.value = null
    recentDataDateTo.value = null
    multipleRowsSelected.value = []
    multipleRowsSent.value = []
    loadingRows.value = []
})
